import React, { useState, lazy, useEffect, useRef } from "react";
import { Box, Typography, Tabs, Tab, Paper, Tooltip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ExpenseCategoryTab from "./expenseCategoryTab";
import IncomeCategoryTab from "./incomeCategorytTab";
import AccountDepartmentTab from "./accountDepartmentTab";
import ExternalSharer from "./externalSharer";

const AccountSettings = () => {
  const navigate = useNavigate();
  const { tab, id, name } = useParams();

  const tabConfigs = [
    { label: "Expense Category", key: "expense" },
    { label: "Procedure ", key: "income" },
    { label: "Account Department", key: "account" },
    { label: "External Share", key: "external" },
  ];

  const visibleTabMap = tabConfigs.reduce((acc, item, index) => {
    acc[item.key] = index;
    return acc;
  }, {} as Record<string, number>);

  const initialTabIndex = tab ? visibleTabMap[tab] ?? 0 : 0;
  const [tabIndex, setTabIndex] = useState<number>(initialTabIndex);
  // const location = "individual";

  useEffect(() => {
    if (tab !== undefined && visibleTabMap[tab] !== undefined) {
      const targetIndex = visibleTabMap[tab];
      if (tabIndex) {
        setTabIndex(targetIndex);
      }
    }
  }, [tab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabKey = tabConfigs[newValue].key;
    let path = `/account-setting/${tabKey}`;

    navigate(path, { replace: true });
    setTabIndex(newValue);
  };

  const renderTabContent = () => {
    const key = tabConfigs[tabIndex]?.key;

    switch (key) {
      case "expense":
        return <ExpenseCategoryTab />;
      case "income":
        return <IncomeCategoryTab />;
      case "account":
        return <AccountDepartmentTab />;
      case "external":
        return <ExternalSharer />;
      default:
        return null;
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        allowScrollButtonsMobile
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: "divider",

          "& .MuiTabs-flexContainer": {
            display: "flex",
            gap: 1,
            justifyContent: "start",
          },
          "& .MuiTab-root": {
            color: "#4d4d4dff",
            textTransform: "none",
            padding: "6px 6px",
            minWidth: "auto",
            fontWeight: "400",
          },
          "& .Mui-disabled": {
            color: "#9e9e9edc !important", // gray text for disabled
            cursor: "not-allowed",
          },
          "& .Mui-selected": {
            color: "primary.main",
          },
        }}
      >
        {tabConfigs.map(tab => (
          <Tab
            key={tab.key}
            label={tab.label}
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
          />
        ))}
      </Tabs>

      <Box sx={{ marginTop: "10px" }}>{renderTabContent()}</Box>
    </Paper>
  );
};

export default AccountSettings;
